<template>
  <div>
    <v-card class="elevation-1 mt-0">
      <v-card-title class="pb-0 pt-2">
        <span class="primary--text">{{ capitalize(resourceName) }}</span>
      </v-card-title>

      <v-card-text pa-2>
        <v-layout flat color="white">
          <div class="search-bar">
            <v-text-field
              @input="updateSearch($event)"
              :label="'Search ' + capitalize(resourceName)"
              solo
              prepend-inner-icon="search"
              block
              hide-details
              v-bind:search.sync="search"
            >
              <template slot="append">
                <component :is="formComponent" />
              </template>
            </v-text-field>
          </div>
        </v-layout>

        <v-data-table
          :headers="headers"
          :items="collection"
          :search="search"
          :rows-per-page-items="pagination"
          flat
        >
          <template slot="items" slot-scope="props">
            <td v-for="header in headers.slice(0, -1)" :key="header.name">
              {{ columnValue(props.item, header) }}
            </td>
            <td>
              <component :is="formComponent" :objectId="props.item.id" />
              <destroyModale
                :resourceName="resourceName"
                :itemId="props.item.id"
                :warningText="
                  'You are going to remove this ' +
                  capitalize(resourceName) +
                  ' permanently.'
                "
              />
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning"
            >Your search for "{{ search }}" found no results.</v-alert
          >
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import searchBar from "./searchBar";

import bankInformationForm from "../companies/bankInformationForm";
import affiliateCompanyForm from "../companies/affiliateCompanyForm";
import documentaryInstructionForm from "../companies/documentaryInstructionForm";
import card from "../../components/shared/card";

export default {
  props: {
    formComponent: {
      type: String,
      required: true,
    },
    resourceName: {
      type: String,
      required: true,
    },
    collectionHeaders: {
      type: Object,
      required: true,
    },
    store: {
      type: String,
      required: true,
    },
  },
  components: {
    card,
    searchBar,
    bankInformationForm,
    affiliateCompanyForm,
    documentaryInstructionForm,
  },
  data() {
    return {
      search: "",
      pagination: [
        10,
        { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
      ],
    };
  },
  computed: {
    collection() {
      return this.$store.getters[`${this.store}/${this.resourceName}`];
    },
    headers() {
      let headers = Object.keys(this.collectionHeaders).map((key) => {
        let res = new Object();
        res.text = this.capitalize(key);
        res.align = "left";
        res.sortable = true;
        if (this.collectionHeaders[key] == "String") res.value = key;
        else if (this.collectionHeaders[key] == "commonResource")
          res.value = key + ".name";
        return res;
      });
      headers.push({ text: "Actions", align: "left", value: "" });
      return headers;
    },
  },
  methods: {
    updateSearch(event) {
      this.search = event;
    },
    columnValue(item, header) {
      if (header.value.endsWith(".name")) {
        let res = item[header.value.replace(".name", "")];
        return res && res.name;
      } else return item[header.value];
    },
    capitalize(string) {
      return (string.charAt(0).toUpperCase() + string.slice(1)).replace(
        "_",
        " "
      );
    },
  },
};
</script>

<style lang="stylus" scoped>
.search-bar {
  background-color: white;
  width: 100%;

}

.search-field {
  padding-right: 20px;
  max-width: 300px;
}
</style>
